import { takeEvery, put, select } from 'redux-saga/effects';

import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { DataRequestActionTypes, InternalActionTypes } from 'constants/actionTypes';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import {
  SYNC_START,
  SYNC_SUCCESS,
  SYNC_FAILURE,
  REFRESH_LIST_SUCCESS,
} from 'components/events/moParticipantsSyncModal/MoParticipantsSyncModal';
import {
  SYNCHRONIZE_MO_EVENT_PARTICIPANTS_REQUEST,
  SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS,
  SYNCHRONIZE_MO_EVENT_PARTICIPANTS_FAILURE,
} from 'api/mo/mo.actions';

function* moParticipantsSyncStart() {
  yield put(createModalOpenAction(SimpleModalId.MoParticipantsSync, { status: SYNC_START }));
}

function* moParticipantsSyncSuccess() {
  yield put(createModalOpenAction(SimpleModalId.MoParticipantsSync, { status: SYNC_SUCCESS }));
}

function* moParticipantsSyncFailure() {
  yield put(createModalOpenAction(SimpleModalId.MoParticipantsSync, { status: SYNC_FAILURE }));
}

function* refreshParticipantsListRequest(action: {
  type: typeof SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS;
  meta: { eventId: string };
}) {
  yield put({ type: DataRequestActionTypes.AllEventParticipantsRequested, ...action.meta });
}

function* refreshParticipantsListSuccess(): Generator<any, void, any> {
  const modal = yield select(
    ({ appStatus: { modals } }: ClippingPlatformState) => modals[SimpleModalId.MoParticipantsSync],
  );

  if (modal && modal.open) {
    yield put(createModalOpenAction(SimpleModalId.MoParticipantsSync, { status: REFRESH_LIST_SUCCESS }));
  }
}

export function* moSagas() {
  yield takeEvery(SYNCHRONIZE_MO_EVENT_PARTICIPANTS_REQUEST, moParticipantsSyncStart);
  yield takeEvery(SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS, moParticipantsSyncSuccess);
  yield takeEvery(SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS, refreshParticipantsListRequest);
  yield takeEvery(SYNCHRONIZE_MO_EVENT_PARTICIPANTS_FAILURE, moParticipantsSyncFailure);

  yield takeEvery(InternalActionTypes.EventParticipantsLoaded, refreshParticipantsListSuccess);
}
